import {
  getGroupsWithPropertiesFetchUrl,
  makeGroupsWithPropertiesQuickFetchKey,
} from './cacheKeys';
import { PromiseClient } from 'hub-http/adapters/promiseClient';
import { CollectionResponseGroupWithPropertyDefinitionsNoPaging } from 'inbound-db-properties-service-client/InboundDbPropertiesService-Unified/types';
import { withQuickFetch } from './withQuickFetch';

export const fetchGroupedProperties = ({
  httpClient,
  frameworkTypeIdentifier,
  query,
}: {
  httpClient: PromiseClient;
  frameworkTypeIdentifier: string;
  query?: { showHighlySensitiveProperties?: boolean };
}) =>
  withQuickFetch({
    requestName: makeGroupsWithPropertiesQuickFetchKey({
      frameworkTypeIdentifier,
      query,
    }),
    baseFetch: () =>
      httpClient.get<CollectionResponseGroupWithPropertyDefinitionsNoPaging>(
        getGroupsWithPropertiesFetchUrl({
          frameworkTypeIdentifier,
          query,
        })
      ),
  }).then(({ results }) => results);
